import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import DeleteButton from "../components/DeleteButton";
import MUIDataTable from "mui-datatables";
import AddWatchModal from "../components/AddWatchModal";
import { AuthContext } from "../context/auth";
import { FETCH_WATCH_TEAM_QUERY } from "../util/graphql";
const TableAttributes = require("../variables/TableAttributes.js");

function WatchList(props) {
  const user = useContext(AuthContext);
  // let newData = [{}];
  let edit;
  const { loading, error, data } = useQuery(FETCH_WATCH_TEAM_QUERY);

  function deletePostCallback() {
    window.location.reload(false);
  }

  if (loading) return "Loading...";
  if (error) return `Error! ${error.message}`;

  if (user) {
    let userId = user.user.id;
    edit = data.getWatchlist
      .filter((o) => o.user === userId)
      .map((o) => ({
        ...o,
        fangraphs: o.fangraphs ? <a href={o.fangraphs}> Player Page </a> : "",
        delete: <DeleteButton postId={o.id} callback={deletePostCallback} />,
      }));
  }

  if (data) {
  }

  return (
    <div>
      <div style={{ paddingTop: 16, paddingBottom: 16 }}>
        <AddWatchModal />
      </div>
      {user && (
        <MUIDataTable
          title={"WatchList"}
          data={edit}
          columns={TableAttributes.watch_columns}
          options={TableAttributes.spec_options}
        />
      )}
    </div>
  );
}

export default WatchList;
